import { API_BASE_URL } from './apiConfig';

export const getMedicalSuppliesForm = async (studentId) => {
  try {
    const response = await fetch(`${API_BASE_URL}/students/medical-supplies-form/${studentId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error fetching medical supplies form:', error);
    throw error;
  }
};
